import React from 'react';

function Pricing() {
  return (
    <section id="pricing" className="bg-white shadow-lg rounded-lg p-8 text-center mx-auto mt-12">
      <h2 className='text-yellow-500 text-2xl font-bold mb-4'>Secure Your Bundle Today</h2>
      <p className="text-gray-700 text-lg mb-2">Get <span className="font-semibold">122 Essential Documents + 20 Bonus Documents</span></p>
      <p className="text-gray-900 text-xl font-semibold mb-4">One-time Investment: <span className="text-green-600">₹ 99.00</span></p>
      
      <div className="bg-gray-100 p-4 rounded-lg shadow-md text-left text-gray-700 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">How to Pay:</h3>
        <p className='text-blue-600'>Make a UPI payment of <span className="font-semibold">₹ 99.00</span> to:</p>
        <p className="text-lg font-semibold text-yellow-500">think5whys@kotak</p>
        <p className="text-sm text-gray-600">(Think5Whys Global DeepTech Solutions, Mumbai, India)</p>
      </div>
      
      <button className="bg-yellow-500 text-blue-600 px-6 py-3 rounded-lg shadow hover:bg-yellow-600 transition text-lg font-medium">
        Pay Now
      </button>
      
      <div className="mt-6 text-sm text-blue-600 text-left">
        <h3 className="text-lg font-semibold text-gray-900">Business Credentials:</h3>
        <p className='text-black'>Registered under Udyam Aadhar: <span className="font-semibold">UDYAM-MH-33-0078034</span></p>
        <p className='text-black'>Importer-Exporter Code (IEC): <span className="font-semibold">AHJPK0214C</span></p>
        <p className='text-black'>Bank: <span className="font-semibold">Kotak Mahindra Bank</span></p>
        <p className='text-black'>Branch: Casa Rio, Palava, Dombivli East, Thane, Mumbai, Maharashtra, India</p>
        <p className='text-black'>PIN: <span className="font-semibold">421204</span></p>
      </div>
      
      <div className="mt-6">
        <h3 className="text-lg font-semibold text-gray-900">About the Creator:</h3>
        <p className='text-black'>Think5Whys Global DeepTech Solutions is a proprietary firm of <span className="font-semibold">Sanjeev Kumar</span></p>
        <a href="https://www.linkedin.com/in/sanjeevkumarmumbai" target="_blank" rel="noopener noreferrer" className="text-yellow-500 font-medium hover:underline">Connect with the Author on LinkedIn</a>
      </div>
    </section>
  );
}


export default Pricing;